import MembershipScreen from '@/screens/join-premium/MembershipScreen'

export default function () {
  return <MembershipScreen />
}
